import { combineReducers } from 'redux';

import { activityReducer } from 'store/modules/activity';
import { appReducer } from 'store/modules/app';
import { entitiesReducer } from 'store/modules/entities/reducers';
import { errorsReducer } from 'store/modules/errors';
import { networkReducer } from 'store/modules/network';
import { paginationReducer } from 'store/modules/pagination';
import { successReducer } from 'store/modules/success';

export const reducer = combineReducers({
  activity: activityReducer,
  app: appReducer,
  entities: entitiesReducer,
  errors: errorsReducer,
  network: networkReducer,
  pagination: paginationReducer,
  success: successReducer,
});
